import { render, staticRenderFns } from "./ApportionmentHistory.vue?vue&type=template&id=75ed2936&"
import script from "./ApportionmentHistory.vue?vue&type=script&lang=js&"
export * from "./ApportionmentHistory.vue?vue&type=script&lang=js&"
import style0 from "./ApportionmentHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports